import React, { createContext, useState, useContext } from 'react';

const TabContext = createContext();

export function TabProvider({ children, initialTabIndex = 0 }) {
  const [activeTabIndex, setActiveTabIndex] = useState(initialTabIndex);

  return (
    <TabContext.Provider value={{ activeTabIndex, setActiveTabIndex }}>
      {children}
    </TabContext.Provider>
  );
}

export function useTabContext() {
  return useContext(TabContext);
}
